import * as R from "ramda";

const UNSUPPORTED_FIELD_TYPES = ["text_insert", "signature", "sensitive"];

export const rejectUnsupportedFields = R.reject(
  R.propSatisfies(R.flip(R.includes)(UNSUPPORTED_FIELD_TYPES), "field_type"),
);

const selectMutationsBy = (key, value) => R.filter(R.propEq(value, key));
const selectRequirementMutations = selectMutationsBy("record_type", "requirement");
export const selectRequirementMutationsOfType = (mutations, type) =>
  R.compose(selectRequirementMutations, selectMutationsBy("type", type))(mutations);
export const selectAnswerMutations = selectMutationsBy("record_type", "field");

export const isChangeset = R.ifElse(
  R.complement(R.isNil),
  R.propEq("Changeset", "type"),
  R.always(false),
);

export const getAsPreviousRecord = (changeset) =>
  R.assoc("answers", R.prop("previous_answers", changeset), changeset);
